import React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { getAdminUsers } from '@disco/state-management/selectors/user'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Heading from 'components/ui/heading'
import Icon from 'components/ui/icon'
import ModalWindow from 'components/ui/modal-window'
import Stack from 'components/ui/stack'
import Tag from 'components/ui/tag'
import Text from 'components/ui/text'

const NonAdminInviteUserModal = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const adminUsers = useSelector(getAdminUsers)

  const onClose = () => {
    navigate('/settings/users')
  }

  return (
    <ModalWindow
      header={<Heading size={700}>Seat limit reached</Heading>}
      footer={
        <div>
          <ButtonContainer alignRight>
            <Button caption="Cancel" onClick={onClose} />
            <Button caption="Got it" appearance="primary" onClick={onClose} />
          </ButtonContainer>
        </div>
      }
      width="medium"
      onClose={onClose}
      isOpen
    >
      <Stack space="small">
        <Text type="paragraph">
          You’ve reached the limit of seats on your account. To invite more
          people, your account admins will need to upgrade to add more seats.
          Your account admins are:
        </Text>
        <ButtonContainer>
          {adminUsers.map(({ user: { id, email } }) => {
            return (
              <div key={id}>
                <Tag
                  tag={email}
                  icon={<Icon type="profile" width="14" height="14" />}
                />
              </div>
            )
          })}
        </ButtonContainer>
      </Stack>
    </ModalWindow>
  )
}

export default NonAdminInviteUserModal
